'use client';

import { Modal } from 'react-bootstrap';
import styles from './cart-success-sheet.module.scss';

interface ModalWrapperSheetProps {
  show: boolean;
  children: React.ReactNode;
  onClose: () => void;
}


const ModalWrapperSheet = ({
  show,
  children,
  onClose
}: ModalWrapperSheetProps) => {
  
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName={styles.cartSuccessSheet}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className={styles.content}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default ModalWrapperSheet;
